import http from '../../http'

export default {
  list: (params) => {
    return http.get("marketcenter/webchatcollocation/appList", params)
  }, //查询公众号列表
  getAvaliableList: (params) => {
    return http.get("marketcenter/webchatcollocation/applistAvaliable", params)
  }, //获取租户可用的公众号列表
  getUrl: (params) => {
    return http.get("marketcenter/webchatcollocation/getUrl", params)
  }, //添加微信号
  add: (params) => {
    return http.get("marketcenter/webchatcollocation/redirectUrl", params)
  }
};
